import React, { useState } from 'react';
import { Play, ChevronDown, Phone, MessageCircle, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { businessInfo } from '@/data/menuData';

// Video URL caricato dall'utente
const HERO_VIDEO_URL = 'https://customer-assets.emergentagent.com/job_sapori-menu/artifacts/fw0d9t3s_11621-231571931_medium.mp4';

export const HeroEcommerce = ({ withHeaderOffset = true }) => {
  const [videoError, setVideoError] = useState(false);

  const scrollToMenu = () => {
    const element = document.getElementById('menu-home');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      className={`relative min-h-[70vh] flex items-center justify-center overflow-hidden ${
        withHeaderOffset ? 'pt-20' : 'pt-8'
      }`}
    >
      <div className="absolute inset-0 z-0">
        {!videoError ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            onError={() => setVideoError(true)}
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={HERO_VIDEO_URL} type="video/mp4" />
          </video>
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-instagram-purple/40 via-instagram-red/30 to-instagram-orange/40" />
        )}

        <div className="absolute inset-0 z-10 bg-gradient-to-b from-foreground/70 via-foreground/50 to-background" />
      </div>

      <div className="relative z-20 mx-auto max-w-4xl px-4 text-center">
        <div className="mb-6 animate-scale-in">
          <img
            src={businessInfo.logo}
            alt={businessInfo.name}
            className="mx-auto h-24 w-24 rounded-full border-4 border-primary-foreground/20 object-cover shadow-2xl sm:h-32 sm:w-32"
          />
        </div>

        <h1
          className="mb-4 animate-slide-up text-4xl font-bold text-white drop-shadow-lg sm:text-5xl lg:text-6xl"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Sapori 1989
        </h1>

        <p className="mb-2 animate-slide-up text-lg text-primary-foreground/90 drop-shadow stagger-1 sm:text-xl">
          {businessInfo.description} • {businessInfo.slogan}
        </p>
        <p className="mb-8 animate-slide-up text-sm text-primary-foreground/70 stagger-2 sm:text-base">
          Ordina online, ritira in sede oppure ricevi a domicilio
        </p>

        <div className="animate-slide-up stagger-3 flex flex-col justify-center gap-4 sm:flex-row">
          <Button
            onClick={scrollToMenu}
            size="lg"
            className="gradient-instagram px-8 text-lg text-primary-foreground shadow-instagram hover:opacity-90"
          >
            <Play className="mr-2 h-5 w-5" fill="currentColor" />
            Ordina Ora
          </Button>

          <div className="flex justify-center gap-3">
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-primary-foreground/30 bg-primary-foreground/10 text-primary-foreground backdrop-blur-sm hover:bg-primary-foreground/20"
            >
              <a href={`tel:${businessInfo.phone}`}>
                <Phone className="mr-2 h-5 w-5" />
                Chiama
              </a>
            </Button>

            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-success/50 bg-success/20 text-primary-foreground hover:bg-success/30"
            >
              <a
                href={`https://wa.me/${businessInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <MessageCircle className="mr-2 h-5 w-5" />
                WhatsApp
              </a>
            </Button>
          </div>
        </div>

        <div className="mt-8 animate-fade-in stagger-4">
          <a
            href={businessInfo.googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-primary-foreground/70 transition-colors hover:text-primary-foreground"
          >
            <MapPin className="h-4 w-4" />
            {businessInfo.address}
          </a>
        </div>

        <div className="mt-12 animate-bounce">
          <ChevronDown className="mx-auto h-8 w-8 text-primary-foreground/50" />
        </div>
      </div>
    </section>
  );
};
